module.exports = __webpack_public_path__ + "media/images/lb/205-bf6122de24025e5cc3ba5648b0609adb.svg";